import { render, staticRenderFns } from "./CustomerCare.vue?vue&type=template&id=2f05920e&"
import script from "./CustomerCare.vue?vue&type=script&lang=ts&"
export * from "./CustomerCare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports